import { gql } from '@apollo/client';

export const GET_USER_AI_CHAT_LOG = gql`
  query getUserAiChatLog($user_id: String!, $lesson: String!, $stage: String!, $app_id: String!) {
    getUserAiChatLog(user_id: $user_id, lesson: $lesson, stage: $stage, app_id: $app_id)
  }
`;
